<template>
  <div class="system-simulation-payment">
    <div class="page-title application-detail-header">
      {{ $t('menu.simulation_collection_verify') }}
    </div>
    <p style="color: red;white-space:pre-line">{{ $t('system.simulation_collection_verify_warning') }}</p>
    <el-card class="box-card">
      <div class="text item">
        <el-form ref="form" :model="search" label-width="150px" :rules="rules" label-position="left">
          <el-form-item :label="$t('system.mch_order_id')" prop="mch_order_id" required>
            <el-input v-model="search.mch_order_id" size="small" :placeholder="$t('system.mch_order_id')" class="search-frame" autocomplete="off" clearable />
          </el-form-item>
          <el-form-item :label="$t('system.amount')" prop="amount" required>
            <el-input v-model="search.amount" size="small" :placeholder="$t('system.amount')" class="search-frame" autocomplete="off" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="listLoading" @click="onSubmit('form')">Submit</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>

import { simulationCollectionVerify } from "@/api/develop-manage/develop-manage";

export default {
  name: 'Develop_Manage_simulation_collection_verify',
  data() {
    return {
      listLoading: false,
      search: {
        mch_order_id: '',
        amount: 0
      },
      rules: {
      }
    }
  },
  mounted() {

  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.listLoading = true
          simulationCollectionVerify(this.search).then(res => {
            if (res.code === 10000) {
              this.$message.success('Success')
            }
          }).finally(() => {
            this.listLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.system-simulation-payment{
  margin: 20px;
  background-color: #fff;
}
</style>
